import React from 'react'

import Offer from './Offer'
import ViewToggle from '../../subcomponents/ViewToggle'
import { FootnotesFromContext } from "../../subcomponents/Footnotes"

const Placeholder = ({ original = null, placeholder }) => (
    <div className="item placeholder">
        {React.cloneElement(
            placeholder || original
        )}
    </div>
)

const Stage = props => (
    <div className="mam3-type border category-banner">
        <div className="wrapper">
            <div className="track">
                <div className="item">
                    <Offer className="banner earn category-stage" {...props} campaign={props.campaign} image={props.image} isArrow={true}  noBorder={true}/>
                    {props.isMobile('web') ? (<div className="indicators">
                        <div className="indicator active"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        
                    </div>) : (<div className="indicators">
                        <div className="indicator active"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                        <div className="indicator"></div>
                    </div>)}
                </div>
                <Placeholder placeholder={props.placeholder} />
                <div className="controls carousel">
                    <button className="next"></button>
                </div>
            </div>
        </div>
    </div>
)

const OfferBanner = props => {
    const data = {
        placeholder: <Offer {...props} campaign=" " noBorder className="banner-placeholder" />
    }

    return (
        <ViewToggle isMobile={props.isMobile('web')}>
            <Stage {...props} placeholder={data.placeholder} campaign={props.campaign} image={props.isMobile('web') ? props.campaign.image_16_9 : props.campaign.image_5_2} />

            <FootnotesFromContext
                showWarningText={props.footnotesWarningText}
                bigIndices={props.bigIndices}
            />
        </ViewToggle>
    )

}

export default OfferBanner



// WEBPACK FOOTER //
// ./src/components/ads/mam3/OfferBanner.js